import { render } from "./GainersLosersPage.vue?vue&type=template&id=eca9be76&ts=true"
import script from "./GainersLosersPage.vue?vue&type=script&lang=ts"
export * from "./GainersLosersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__